import { printReportService, IReportFile } from '@tap/data-providers';

export type IPrintReportFiles = {
    requestData: any,
    setIsLoading: (value: boolean) => void,
    showError: (message: string) => void,
    reportName: string,
}

export enum ReportNames {
    ShiftDailyTask = 'ShiftDailyTask',
    ToolIssuing = 'ToolIssuing',
    ToolReturns = 'ToolReturns',
    WIPChange = 'WIPChange',
    ConsumptionEndProducts = 'ConsumptionEndProducts',
    RouteAndTechnologicalMap = 'RouteAndTechnologicalMap',
}

export const printReportFiles = ({ requestData, setIsLoading, showError, reportName }: IPrintReportFiles): void => {
    setIsLoading(true);
    printReportService.printReportFile(requestData, reportName)
        .then((res: IReportFile) => {
            const blob = new File([res.file], `${reportName}.pdf`, { type: res.type });
            const downloadUrl = window.URL.createObjectURL(blob);
            setIsLoading(false);
            window.open(downloadUrl, '_blank');
        })
        .catch(() => {
            setIsLoading(false);
            showError('Произошла ошибка при загрузке печатной формы.');
        });
};